import React from "../../_snowpack/pkg/react.js";
const BoxOrderDetailScreen = ({boxId}) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: "has-header"
  }, "order details for box with id ", boxId);
};
export default BoxOrderDetailScreen;
